import { ConfigState } from "./configState/reducer";

export const getEnvConfig = (): ConfigState => {
  let env = (window as any).ENV;
  if (env === undefined) {
    if (process.env.NODE_ENV !== "test") {
      // tslint:disable-next-line: no-console
      console.warn("Couldn't load environment config");
    }
    env = {};
  }
  return {
    enableCreditLens: window.location.pathname.startsWith("/creditlens"),
    enableFlyoutReasons: env.REACT_APP_ENABLE_FLYOUT_REASONS === "true",
    baseApiUrl: env.REACT_APP_MIDAS_API_URL,
    ssoBaseApiUrl: env.SSO_API_URL,
    ssoRedirectUrl: env.SSO_REDIRECT_URL,
    ssoSignoutUrl: env.SSO_SIGNOUT_REDIRECT_URL,
    ssoCredentials: env.SSO_APP_CREDENTIALS,
    creditLensPathPrefix: env.REACT_APP_CREDIT_LENS_PATH_PREFIX,
    localAuthPath: env.REACT_APP_MIDAS_LOCAL_AUTH_PATH,
    documentsPollIntervalMs:
      parseInt(env.REACT_APP_DOCUMENTS_POLL_INTERVAL, 10) || 60_000,
    unmappedAccountsEnabled: env.REACT_APP_FEATURE_UNMAPPED_ACCOUNTS === "true",
    dbsJwtLoginEnabled: env.REACT_APP_ENABLE_DBS_JWT_LOGIN === "true",
    dbsUploadButtonEnabled: env.REACT_APP_ENABLE_DBS_UPLOAD_BUTTON === "true",
    pageSize: parseInt(env.PAGE_SIZE, undefined),
    env: env.ENV
  };
};



// WEBPACK FOOTER //
// ./src/envConfig.ts